import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "./apiConfig";

// Define the initial state for the authentication part of the Redux store
const initialState = {
  formData: {}, // Holds form data
  isLoading: false, // TMark as loading on request start
  isSubmitted: false, // Mark as submitted on request completion
};

export const putDemoRequest = createAsyncThunk("requestDemo/putDemoRequest", async ({ firstName, lastName, email, companySize, industry, requestContent }, { rejectWithValue }) => {
  const formData = JSON.stringify({
    first_name: firstName,
    last_name: lastName,
    email: email,
    company_size: companySize,
    industry: industry,
    product_link: requestContent, // Assuming this maps to a "product link" field.
  });

  return fetch(BASE_URL + "/put-demo-request", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: formData,
  })
    .then((res) => {
      if (!res.ok) {
        // Manually throw an error if the HTTP response is not ok
        return rejectWithValue(`HTTP error! status: ${res.status}`);
      }
    })
    .catch((error) => {
      return rejectWithValue(error.message);
    });
});

const requestDemoSlice = createSlice({
  name: "requestDemo",
  initialState,
  reducers: {
    // Initialize request state
    initializeRequest: (state, action) => {
      state.formData = action.payload;
      state.isLoading = false;
      state.isSubmitted = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(putDemoRequest.pending, (state) => {
        state.isLoading = true;
        state.isSubmitted = false;
      })
      .addCase(putDemoRequest.fulfilled, (state) => {
        state.isLoading = false;
        state.isSubmitted = true;
      })
      .addCase(putDemoRequest.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// Export the action creator for submitting a request
export const { initializeRequest } = requestDemoSlice.actions;

export default requestDemoSlice.reducer;
